import Image from "next/legacy/image";

import styles from "./OurValuesCard.module.scss";

const OurValuesCard = ({ ourData }) => {
  return (
    <>
      {ourData.map((item, index) => (
        <div className={`${styles.singleValue}`} key={index}>
          <h3 className={`${styles.titleContainer}`}>
            <Image
              src={item.icon.data.attributes.url}
              alt="Values icon"
              width="40"
              height="40"
              loading={"lazy"}
            />
            <span className={`${styles.title}`}>{item.title}</span>
          </h3>

          <p className={`${styles.text}`}>{item.description}</p>
        </div>
      ))}
    </>
  );
};
export default OurValuesCard;
